module.exports = __webpack_public_path__ + "img/showerWhite.861b0dd4.svg";